module.exports = __webpack_public_path__ + "static/media/ic_day_check_green.fa8796cb.svg";